import React, { useState } from "react";
import "./Header.css";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Link, useLocation, useNavigate } from "react-router-dom";

function Header() {
  const location = useLocation();
  const navigate = useNavigate();


  const [show, setShow] = useState(false);


  const handleNavClick = () => {
    setShow(false);
  };
  const isSpecialPage = location.pathname === "/contact-us" || location.pathname === "/about-us";

  return (
    <section className="header_section">
      <Navbar expand="lg" className={`Nav ${isSpecialPage ? "remove-nav-after" : ""}`} expanded={show} >
        <Container>

          <img
            src={process.env.PUBLIC_URL + "/Assets/Images/logo/Absar_logo.png"}
            alt="logo"
            className="nav-logo"
            onClick={() => navigate("/")}
          />


          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            onClick={() => setShow(!show)}
          />

          <Navbar.Collapse id="basic-navbar-nav">
            <div className="top_bar ms-auto">
              <div className="contact_info">
                <a className="fa-text">
                  <i className="fa fa-phone fa-icon" /> 7668201518
                </a>
                <a className="fa-text">
                  <i className="fa fa-envelope fa-icon" /> absarmoney@gmail.com
                </a>
              </div>
              <Nav>
                <Nav.Link
                  as={Link}
                  to="/"
                  className={location.pathname === "/" ? "active" : ""}
                  onClick={handleNavClick}
                >
                  HOME
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/about-us"
                  className={location.pathname === "/about-us" ? "active" : ""}
                  onClick={handleNavClick}
                >
                  ABOUT US
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/contact-us"
                  className={location.pathname === "/contact-us" ? "active" : ""}
                  onClick={handleNavClick}
                >
                  CONTACT US
                </Nav.Link>
              </Nav>
            </div>
            <div className="angled-border">
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </section>
  );
}

export default Header;
